import { render } from "./my.vue?vue&type=template&id=3a72b343&scoped=true&ts=true"
import script from "./my.vue?vue&type=script&lang=ts"
export * from "./my.vue?vue&type=script&lang=ts"

import "./my.vue?vue&type=style&index=0&id=3a72b343&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a72b343"]])

export default __exports__